import { mapState } from 'vuex';
import { apiCallers } from '@/api/apiRequest';
import { downloadBase64 } from '@/utils/download';
import { formatMoney, randomStr } from '@/modules/utils';

import Chart from './chart';
import NNumber from '@/components/common/n-number.vue';
import NRadio from '@/components/common/n-radio.vue';
import ScrollHandler from '@/mixins/scrollHandler.js';
import ThemeHandler from '@/mixins/themeHandler.js';
import TrackingHandler from '@/mixins/trackingHandler.js';

const POLL_INTERVAL = 500;

export default {
  components: {
    Chart,
    NNumber,
    NRadio,
  },

  mixins: [
    ScrollHandler,
    ThemeHandler,
    TrackingHandler
  ],

  data() {
    return {
      /* global __CURRENT_BUILDTARGET */
      buildTarget: __CURRENT_BUILDTARGET,
      checkValid: false,
      debounceTimeoutMaxId: null,
      debounceTimeoutConfigId: null,
      debounceTimeoutPromotionId: null,
      frmCurrent: {
        pension_fee: '',
        pension_beamte: '',
        pension_statual: '',
        pension_agricul: '',
        pension_basic: '',
      },
      frmMarital: {
        marital_status: 1,
        birth_year: '',
        retire_age: 0,
        taxable_income: '',
      },
      frmDesired: {
        payment: false,
        beitrag: '',
        extra: '',
      },
      optionsPayment: [
        { label: 'Regelmäßiger Jahresbeitrag', value: 1 },
        { label: 'Einmalzahlung', value: 2 },
      ],
      pdfJobId: null,
      pdfPollTimer: null,
      resultConfig: {
        hoechstbetrag_single: 0,
        hoechstbetrag_spouses: 0,
        landwirtschaft_max: 0,
        landwirtschaft_min: 0,
        max_foerder_single: 0,
        max_foerder_spouses: 0,
        wunsch_beitrag_min: 0,
        Year: 0
      },
      resultLoading: false,
      resultPromotion: null,
      showForm1: true,
      showForm2: false,
      showFrmCurrent: 0,

      fieldNames: {
        pension_fee: 'versorgungswerk',
        pension_beamte: 'gesetzliche_rente',
        pension_statual: 'gesetzliche_rente',
        pension_agricul: 'landwirtschaft',
        pension_basic: 'bestehende_basisrente',
        marital_status: 'familienstand',
        birth_year: 'geburtsjahr',
        retire_age: 'rentenbeginn',
        taxable_income: 'zv_einkommen',
        beitrag: 'jahresbeitrag',
        extra: 'zuzahlung',
      }
    };
  },
  computed: {
    ...mapState([
      'appConfigs'
    ]),

    apiRequest () {
      return apiCallers[this.config.app];
    },

    config () {
      return this.appConfigs[this.$options.configIndex] || {};
    },

    currentYear() {
      return this.resultConfig && this.resultConfig.Year
        ? this.resultConfig.Year
        : new Date().getFullYear();
    },

    text () {
      return {
        intro_main: 'Der maximal steuerlich geförderte BasisRenten-Beitrag ist abhängig davon, wie Sie vom Finanzamt veranlagt werden. In der Regel ergibt sich das aus Ihrem Familienstand. Die Höhe Ihres Steuervorteils errechnet sich aus Ihrem zu versteuernden Jahreseinkommen und Ihren Jahresbeiträgen in bereits bestehende Vorsorgeversicherungen.',
        intro_current: 'Beiträge in bestehende Vorsorgeversicherungen mindern Ihren maximal steuerlich geförderten Beitrag',
        label_material: 'Familienstand',
        label_taxable: 'zu versteuerndes Jahreseinkommen',
        label_retirement: 'Rentenbeginn*',
        title_main: 'Ihre persönliche Situation',
        title_current: 'Ihre bestehenden Vorsorgeversicherungen',
        title_desired: 'Ihr BasisRenten-Wunschbeitrag',
        title_chart: 'Ihr Steuervorteil',
        title_table: 'Jahresüberblick',
        tooltip_material: `Alleinstehend:<br>Sie sind ledig, alleinstehend oder Sie werden vom Finanzamt einzeln veranlagt. Es werden maximal ${ formatMoney(this.maxConfig.max_single) } € pro Jahr steuerlich gefördert.<br><br>`
          + `Verheiratet / verpartnert:<br>Sie werden vom Finanzamt zusammen veranlagt. Es werden maximal ${ formatMoney(this.maxConfig.max_spouses) } € pro Jahr steuerlich gefördert.`,
        tooltip_taxable: 'Ihr Steuervorteil errechnet sich aus dem zu versteuernden Einkommen. Es ist im Einkommensteuerbescheid als konkreter Betrag aufgeführt. Das zu versteuernde Einkommen ergibt sich aus den gesamten steuerlichen Einnahmen - bei Zusammenveranlagung beider Ehe-/Lebenspartner - abzüglich von Werbungskosten und Betriebsausgaben, sowie abzüglich von steuerlichen Freibeträgen (z.B. Kinderfreibetrag), Sonderausgaben (z.B. Vorsorgeaufwendungen) und außergewöhnlichen Belastungen.',
        tooltip_retirement: 'Sie können Ihren Rentenbeginn individuell zwischen dem 62. und 67. Geburtstag wählen.',
        footer: [
          'Diese Berechnung ist unverbindlich und erhebt keinen Anspruch auf Vollständigkeit.',
          'Die Höhe der möglichen Steuervorteile basiert auf dem aktuellen Kenntnisstand und den gültigen Gesetzen mit Stand 1.1.' + this.currentYear + '. Auch Steuervorteile, die für künftige Jahre ausgewiesen werden, wurden auf dieser Grundlage ermittelt. Bitte beachten Sie, dass sich die Gesetzes- und Rechtslage ändern kann und dass dies Einfluss auf die Höhe der Steuerersparnis haben kann.',
          'Die Steuerersparnis stellt lediglich eine Modellrechnung unter Berücksichtigung der individuellen Eingaben dar, da bei der Berechnung unter anderem vom voraussichtlichen Einkommen ausgegangen wird.',
          'Aufgrund der Modellhaftigkeit unserer Berechnungen kann es im Verhältnis zur tatsächlichen Steuerberechnung zu Abweichungen kommen. So werden in diesem Modell beispielsweise Beiträge zur Krankenversicherung oder die gezahlte Kirchensteuer beim Sonderausgabenabzug nicht berücksichtigt. Die Berechnung der tatsächlichen Steuerersparnis kann nur unter Zugrundelegung aller Gesamtumstände des individuellen Einzelfalls ermittelt werden und ersetzt nicht die Hinzuziehung eines steuerlichen Beraters.',
        ]
      };
    },

    minBirthYear() {
      console.log('current year:', this.currentYear);
      console.log('min year:', this.currentYear - 66);
      return this.currentYear - 66;
    },

    maxBirthYear() {
      return this.currentYear - 14;
    },

    retireAges() {
      let options = [
        { label: 'Bitte wählen', value: 0 },
        { label: '62 Jahre', value: 62 },
        { label: '63 Jahre', value: 63 },
        { label: '64 Jahre', value: 64 },
        { label: '65 Jahre', value: 65 },
        { label: '66 Jahre', value: 66 },
        { label: '67 Jahre', value: 67 },
      ];

      let age = this.currentYear - this.frmMarital.birth_year;

      return options
        .filter(option => (
          !option.value || option.value >= age + 1
        ));
    },

    chartData() {
      return [
        {
          name: 'Nettoaufwand',
          value: this.resultPromotion ? this.resultPromotion.netto : 0,
          color: this.config.theme === 'vkb' ? '#14885E' : this.config.theme === 'slv' ? '#024589' : '#DE2920',
          selected: false
        },
        {
          name: 'Steuervorteil',
          value: this.resultPromotion ? this.resultPromotion.steuervorteil : 0,
          color: this.config.theme === 'vkb' ? '#94AE47' : '#666666',
          selected: true
        },
      ];
    },

    currentPension() {
      const beme = this.resultConfig.bemessungsgrenze_ost || 0;
      const bemeY = formatMoney(beme);
      const bemeM = formatMoney(Math.round(beme / 12));
      return [
        {
          id: 'pension_fee',
          label: 'Versorgungswerk',
          tooltip: 'Versorgungswerk ist die auf einer gesetzlichen Pflichtmitgliedschaft beruhende Altersversorgung für kammerfähige freie Berufe. Dazu zählen z.B. Ärzte, Apotheker, Architekten, Notare, Patentanwälte, Rechtsanwälte, Steuerberater, Tierärzte, Wirtschaftsprüfer. Bei zusammenveranlagten Ehepaaren bzw. Lebenspartnerschaften, bei denen beide einem kammerfähigem freien Beruf angehören, sind Beiträge beider Ehe-/Lebenspartner zu berücksichtigen.',
        },
        {
          id: 'pension_beamte',
          label: 'Fiktiver Jahresbeitrag für Beamte',
          tooltip: 'Bei Beamten wird ein fiktiver Höchstbeitrag zur gesetzlichen Rentenversicherung bis zur Beitragsbemessungsgrenze Ost abgezogen. ' + this.currentYear + ' beträgt die Beitragsbemessungsgrenze Ost ' +bemeY +'€ jährlich / ' + bemeM + '€ monatlich.',
          error: this.getErrorMessage('pension_beamte', 'frmCurrent'),
        },
        {
          id: 'pension_statual',
          label: 'gesetzliche Rentenversicherung',
          tooltip: 'Abhängig beschäftigte Arbeitnehmer sind gesetzlich verpflichtet, in die gesetzliche Rentenversicherung einzuzahlen. Freiberufler und Selbstständige können freiwillig einzahlen. Der Höchstbeitrag in der gesetzlichen Rentenversicherung beträgt ' + formatMoney(this.resultConfig.hoechstbetrag_single) + ' Euro im Jahr ' + this.currentYear + ' (' + formatMoney(this.resultConfig.hoechstbetrag_spouses) + ' Euro, wenn beide Ehegatten bzw. Lebenspartner Arbeitnehmer sind). Bitte geben Sie Ihren Eigenanteil, als auch einen eventl. Arbeitgeberanteil ein. Die Höhe der Beiträge finden Sie u.a. auf Ihrer Gehaltsabrechnung.',
          error: this.getErrorMessage('pension_statual', 'frmCurrent'),
        },
        {
          id: 'pension_agricul',
          label: 'landwirtschaftliche Alterskasse',
          tooltip: 'Die landwirtschaftliche Alterskasse ist die Alterssicherung der Landwirte. Hier können der Landwirt, sein Ehegatte/Lebenspartner und ggf. mitarbeitende Familienangehörige versichert sein. Beiträge zur landwirtschaftlichen Alterskasse, die dem Aufbau einer Altersversorgung dienen, können steuerlich geltend gemacht werden.',
          error: this.errorMessages.pension_agricul.between,
        },
        {
          id: 'pension_basic',
          label: 'bestehende BasisRente',
          tooltip: 'Geben Sie hier bitte alle Beiträge an, die Sie oder Ihr mit Ihnen zusammenveranlagter Ehegatte bzw. Lebenspartner in bereits bestehende BasisRenten-Versicherungen einzahlen.',
          error: this.errorMessages.pension_basic.max,
        }
      ];
    },

    maxConfig() {
      return {
        max_single:  this.resultConfig.max_foerder_single,
        max_spouses: this.resultConfig.max_foerder_spouses,
        max_beamte:
          this.frmMarital.marital_status == 1
            ? this.resultConfig.max_beamte_single
            : this.resultConfig.max_beamte_spouses,
        max_fee:
          this.frmMarital.marital_status == 1
            ? this.resultConfig.hoechstbetrag_single
            : this.resultConfig.hoechstbetrag_spouses,
        max_statual:
          this.frmMarital.marital_status == 1
            ? this.resultConfig.max_foerder_single
            : this.resultConfig.max_foerder_spouses,
        max_agricul: this.resultConfig.landwirtschaft_max,
        min_agricul: this.resultConfig.landwirtschaft_min,
        min_desired: this.resultConfig.wunsch_beitrag_min,
        min_onetime: 5000,
        min_annual:  this.resultConfig.wunsch_beitrag_min,
        min_extra:   this.resultConfig.wunsch_beitrag_min,
      };
    },

    optionsMarital() {
      return [
        { label: 'Alleinstehend', value: 1 },
        { label: 'Verheiratet / verpartnert', value: 2 },
      ];
    },

    resultDesired() {
      return [
        {
          label: 'Mein Bruttoaufwand',
          value: this.resultPromotion
            ? formatMoney(this.resultPromotion.brutto, 2)
            : 0,
        },
        {
          label: 'Mein Steuervorteil',
          value: this.resultPromotion
            ? formatMoney(this.resultPromotion.steuervorteil, 2)
            : 0,
        },
        {
          label: 'Mein Nettoaufwand',
          value: this.resultPromotion
            ? formatMoney(this.resultPromotion.netto, 2)
            : 0,
        }
      ];
    },

    validForm1() {
      return !this.$v.frmCurrent.$invalid && !this.$v.frmMarital.$invalid;
    },

    validForm2() {
      return !this.$v.frmDesired.$invalid;
    },

    validIncomeValue() {
     return 1;
    },

    errorMessages() {
      const beitragMessage = this.frmDesired.payment
        ? `Bitte wählen Sie Ihren Beitrag so, dass Ihr maximal geförderter BasisRenten-Beitrag für das Jahr ${ this.currentYear } nicht überschritten wird. Die Eingabe darf den Wert von ${ formatMoney(this.maxConfig.min_onetime) }\xa0€ nicht unterschreiten.`
        : `Bitte wählen Sie Ihren Beitrag so, dass Ihr maximal geförderter BasisRenten-Beitrag für das Jahr ${ this.currentYear } nicht überschritten wird. Die Eingabe darf den Wert von ${ formatMoney(this.maxConfig.min_annual) }\xa0€ nicht unterschreiten.`;

      const extraMessage = !this.frmDesired.payment
        ? `Bitte wählen Sie Ihren Beitrag so, dass Ihr maximal geförderter BasisRenten-Beitrag für das Jahr ${ this.currentYear } nicht überschritten wird. Die Eingabe darf den Wert von ${ formatMoney(this.maxConfig.min_annual) }\xa0€ nicht unterschreiten.`
        : '';

      return {
        pension_beamte: {
          max: `Die Eingabe darf den Wert von ${ formatMoney(this.maxConfig.max_beamte) }\xa0€ nicht überschreiten.`,
          either: 'Entweder "gesetzliche Rentenversicherung" oder "Fiktiver Jahresbeitrag für Beamte" angeben.',
          required_optional: 'Bitte mindestens einen Wert angeben',
        },
        pension_statual: {
          max: `Die Eingabe darf den Wert von ${ formatMoney(this.maxConfig.max_fee) }\xa0€ nicht überschreiten.`,
          either: 'Entweder "gesetzliche Rentenversicherung" oder "Fiktiver Jahresbeitrag für Beamte" angeben.',
          required_optional: 'Bitte mindestens einen Wert angeben',
        },
        pension_agricul: {
          between: `Bitte geben Sie einen Betrag zwischen ${ formatMoney(this.maxConfig.min_agricul) }\xa0€ und ${ this.maxConfig.max_agricul }\xa0€ an.`
        },
        pension_basic: {
          max: `Der angegebene Wert darf ${ formatMoney(this.frmMarital.marital_status === 1 ? this.resultConfig.max_foerder_single : this.resultConfig.max_foerder_spouses) } € nicht überschreiten`
        },
        birth_year: {
          valid: `Bitte wählen Sie ein Geburtsjahr zwischen ${ this.minBirthYear } und ${ this.maxBirthYear }`
        },
        retire_age: {
          valid: 'Bitte wählen Sie Ihren geplanten Rentenbeginn.'
        },
        taxable_income: {
          valid: `Bitte wählen Sie ein zu versteuerndes Jahreseinkommen. Die Eingabe darf den Wert von ${ this.validIncomeValue } nicht unterschreiten.`
        },
        beitrag: {
          valid: beitragMessage,
          between: beitragMessage
        },
        extra: {
          between: extraMessage
        }
      };
    }
  },

  mounted() {
    this.loadResultConfig(false);
    this.triggerTransitionEvent('schnellrechner', 1, 'persoenlicheSituation', 1, 'bestehendeVorsorge');
  },

  methods: {
    formatMoney,

    checkPDF () {
      this.apiRequest
        .get(`${this.config.paths.taskData}${this.pdfJobId}/`, {
          params: { anti_cache: randomStr() }
        })
        .then(response => {
          if (response && response.data) {
            if (response.data.status === 1) {
              throw new Error('Not finished');
            }
            const pdfData = response.data.status_data.data;
            const fileName = this.getPDFName('Ruerup_Rente.pdf');
            downloadBase64(pdfData, fileName);
            this.pdfPollTimer = null;
            this.pdfJobId = null;
          }
        })
        .catch(() => {
          this.pdfPollTimer = setTimeout(this.checkPDF, POLL_INTERVAL);
        });
    },

    getErrorMessage (fieldName, formName) {
      if (formName && !this.$v[formName]) {
        return '';
      }
      let $v_ = null;
      if (!formName) {
        $v_ = this.$v[fieldName];
      } else {
        if (!this.$v[formName] || !this.$v[formName][fieldName]) {
          return '';
        }
        $v_ = this.$v[formName][fieldName];
      }
      if (!$v_.$invalid) {
        return '';
      }
      let validationId = '';
      Object.keys($v_.$params).forEach(p => {
        if ($v_[p] === false) {
          validationId = p;
        }
      });
      return validationId ? this.errorMessages[fieldName][validationId] : '';
    },

    loadResultConfig(delay = true) {
      clearTimeout(this.debounceTimeoutConfigId);
      this.debounceTimeoutConfigId = setTimeout(() => {
        if (this.apiRequest) {
          this.apiRequest
            .get(this.config.paths.config, { params: { year: 0, customer: '' } })
            .then(response => {
              if (response && response.data) {
                this.resultConfig = response.data;
              }
            });
        }
      }, delay ? 500 : 0);
    },

    loadResultPromotion(delay = true) {
      clearTimeout(this.debounceTimeoutPromotionId);
      this.debounceTimeoutPromotionId = setTimeout(() => {
        if (this.apiRequest) {
          const params = {
            year: this.currentYear,
            customer: '',

            familienstand: this.frmMarital.marital_status,
            geburtsjahr: this.frmMarital.birth_year,
            rentenbeginn: this.frmMarital.retire_age,

            gesetzliche_rente: 0,
            versorgungswerk: this.frmCurrent.pension_fee || 0,
            landwirtschaft: this.frmCurrent.pension_agricul || 0,
            bestehende_basisrente: this.frmCurrent.pension_basic || 0,

            zv_einkommen: this.frmMarital.taxable_income,

            jahresbeitrag: this.frmDesired.payment ? 0 : this.frmDesired.beitrag ,
            zuzahlung: !this.frmDesired.payment ? this.frmDesired.extra : this.frmDesired.beitrag,
          };

          if (this.frmMarital.marital_status === 1) {
            // for "Alleinstehend", only one value is available
            params.gesetzliche_rente = this.frmCurrent.pension_beamte || this.frmCurrent.pension_statual || 0;
          } else {
            // for "Verheiratet", sum up both values
            params.gesetzliche_rente = (this.frmCurrent.pension_beamte || 0) + (this.frmCurrent.pension_statual || 0);
          }

          this.resultLoading = true;

          this.apiRequest
            .get(this.config.paths.foerderung, { params })
            .then(response => {
              if (response && response.data) {
                this.resultPromotion = response.data;

                setTimeout(() => {
                  this.scrollToElement('result', 0);
                }, 300);
              }
            })
            .finally(() => {
              this.resultLoading = false;
            });
        }
      }, delay ? 500 : 0);
    },

    onCheckValidClick(e) {
      e.preventDefault();

      this.checkValid = true;

      const trackingKeys = [
        ...Object.keys(this.frmCurrent),
        ...Object.keys(this.frmMarital)
      ];

      const validation = {
        ...this.$v.frmCurrent,
        ...this.$v.frmMarital
      };

      this.triggerValidationEvent(validation, trackingKeys, this.errorMessages, this.fieldNames);

      if (this.validForm1) {
        this.checkValid = false;
        this.showForm1 = false;
        this.showForm2 = true;
        // this.scrollToElement('form2', 0)
        setTimeout(() => {
          this.scrollToElement('form2', 0);
          this.triggerTransitionEvent('schnellrechner', 1, 'persoenlicheSituation', 2, 'wunschbeitrag');
        }, 200);
      }
    },

    onShowFrmCurrent (e) {
      this.showFrmCurrent = e;
      if (!e) {
        this.frmCurrent = {
          pension_fee: '',
          pension_beamte: '',
          pension_statual: '',
          pension_agricul: '',
          pension_basic: '',
        };
      }
    },

    onShowForm1(e) {
      e.preventDefault();
      this.showForm1 = true;
    },

    onBerechnenClick(e, bReset = false) {
      e.preventDefault();

      if (bReset) {
        this.resetForm();
        this.scrollToElement('heading', 0);
        this.triggerActionEvent('neuBerechnen (submit)');
        this.triggerTransitionEvent('schnellrechner', 1, 'persoenlicheSituation', 1, 'bestehendeVorsorge');
        return false;
      }

      this.triggerValidationEvent(this.$v.frmDesired, ['beitrag', 'extra'], this.errorMessages, this.fieldNames);

      this.checkValid = true;

      if (this.$v.$invalid || this.resultLoading) {
        return false;
      }

      this.loadResultPromotion();
      this.triggerTransitionEvent('schnellrechner', 1, 'persoenlicheSituation', 3, 'steuervorteil');
    },

    onChangeMarital(value) {
      this.frmMarital.marital_status = value;
      // this.frmMarital.taxable_income = '';
    },

    onContactClick(e) {
      e.preventDefault();

      this.triggerActionEvent('zurBeratung (submit)');

      if (this.config.contact_url) {
        window.open(this.config.contact_url, '_top');
        return false;
      }

      if (this.config.theme === 'fsoel') {
        window.open('https://www.feuersozietaet.de/content/_resources/beratersuche/', '_top');
        return false;
      }

      window.open('https://www.vkb.de/content/versicherungen/rente/gefoerderte-rente/ruerup-rente/beraten-anfragen/', '_top');
    },

    onGetPdfClick(e) {

      e.preventDefault();

     

      this.triggerActionEvent('steuervorteilDrucken (submit)');

      if (this.$v.$invalid || this.pdfJobId || !this.resultPromotion) {
        return false;
      }

      const pdfData = Object.assign(
        {
          chartData: this.chartData,
          year: this.currentYear
        },
        this.frmCurrent,
        this.frmMarital,
        this.frmDesired,
        this.resultPromotion
      );

      const _pdfData = {
        anti_cache: randomStr(),
        data: JSON.stringify(pdfData),
        preview: false,
        template_name: 'ruerup',
        theme: this.getPDFTheme()
      };

      this.apiRequest
        .get(this.config.paths.pdf, { params: _pdfData })
        .then(response => {
          if (response && response.data && response.data.id) {
            this.pdfJobId = response.data.id;
            this.pdfPollTimer = setTimeout(this.checkPDF, POLL_INTERVAL);
          }
        })
        .catch(() => {
          this.pdfJobId = null;
        });
    },

    onInputBirthYear() {
      this.frmMarital.retire_age = 0;
    },

    resetForm() {
      Object.keys(this.frmCurrent).map(_key => {
        this.frmCurrent[_key] = '';
      });
      this.resetFormDesired();
      this.frmMarital = {
        marital_status: 1,
        taxable_income: '',
        retire_age: 0,
      };
      this.checkValid = false;
      this.resultPromotion = null;
      this.showForm1 = true;
      this.showForm2 = false;
    },

    resetFormDesired() {
      this.frmDesired.payment = false;
      this.frmDesired.beitrag = '';
      this.frmDesired.extra = '';
    }
  },

  watch: {
    frmCurrent: {
      deep: true,
      handler() {
        this.resultPromotion = null;
      }
    },
    frmMarital: {
      deep: true,
      handler() {
        this.resultPromotion = null;
      },
    },
    frmDesired: {
      deep: true,
      handler() {
        this.resultPromotion = null;
      }
    }
  },

  validations: {
    frmCurrent: {
      pension_beamte: {
        max(value) {
          return !this.showFrmCurrent || value <= this.maxConfig.max_beamte;
        },
        either (value) {
          if (!this.showFrmCurrent || !value || this.frmMarital.marital_status === 2) { // this validation does not trigger for "Verheiratet / verpartnert"
            return true;
          }
          return !this.frmCurrent.pension_statual;
        },
        required_optional () {
          return true;
        }
      },
      pension_statual: {
        max(value) {
          return !this.showFrmCurrent || value <= this.maxConfig.max_fee;
        },
        either (value) {
          if (!this.showFrmCurrent || !value || this.frmMarital.marital_status === 2) { // this validation does not trigger for "Verheiratet / verpartnert"
            return true;
          }
          return !this.frmCurrent.pension_beamte;
        },
        required_optional () {
          return true;
        }
      },
      pension_agricul: {
        between(value) {
          if (!this.showFrmCurrent || !value) {
            return true;
          }
          return value >= this.maxConfig.min_agricul && value <= this.maxConfig.max_agricul;
        }
      },
      pension_basic: {
        max(value) {
          return this.frmMarital.marital_status === 1 
            ? value <= this.resultConfig.max_foerder_single
            : value <= this.resultConfig.max_foerder_spouses;
        }
      }
    },
    frmMarital: {
      birth_year: {
        valid(value) {
          return value >= this.minBirthYear && value <= this.maxBirthYear;
        }
      },
      retire_age: {
        valid(value) {
          return value > 0;
        }
      },
      taxable_income: {
        valid(value) {
          return !!value && value >= this.validIncomeValue;
        }
      }
    },
    frmDesired: {
      beitrag: {
        valid(value) {
          return !!value;
        },
        between(value) {
          if (!this.frmDesired.payment) {
            return value >= this.maxConfig.min_annual/*  && value <= this.maxConfig.max_annual */;
          } else if (this.frmDesired.payment) {
            return value >= this.maxConfig.min_onetime/*  && value <= this.maxConfig.max_onetime */;
          }
          return true;
        }
      },
      extra: {
        between(value) {
          if (!value) {
            return true;
          }
          return this.frmDesired.payment || value >= this.maxConfig.min_extra;
        }
      }
    }
  }
};



// WEBPACK FOOTER //
// ./src/apps/ruerup_rente/logic.js